import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "news" }
const _hoisted_2 = { class: "news-banner" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "news-content" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "content" }
const _hoisted_8 = { class: "title" }
const _hoisted_9 = { class: "detail" }
const _hoisted_10 = { class: "createTime" }

import { ref, watch, onMounted, onUnmounted, reactive } from 'vue'
import { selectCommonElement, addConsult } from '@/api'
import router from '@/router';
import { asynchronousRetrieval } from '@/utils'

// 组件名称，用于 keep-alive 的 include 属性匹配
// 必须与 App.vue 中 keepAliveComponents 数组中的名称一致
const __default__ = {
  name: 'MobileNews'
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const loadUrl: any = ref({})

const newsList: any = ref([])

const toOtherPath = (relatedHtmlId: number, title: string) => {
  router.push(`/details?relatedHtmlId=${relatedHtmlId}`)
}

const formatDate = (timestamp: number) => {

   const date = new Date(timestamp)
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    const h = date.getHours();
    const mx = date.getMinutes();
    const s = date.getSeconds();

    return `${y}-${m}-${d}`
}



onMounted(async () => {
  // 条件判断：只有当数据为空时才请求接口
  // 因为组件被 keep-alive 缓存，再次进入页面时 onMounted 仍会执行
  // 但数据已经存在，不需要重新请求
  if (newsList.value.length === 0) {
    selectCommonElement({ columnId: 5, appId: 2 }).then((res: any) => {
      newsList.value = [...res].sort((a: any, b: any) => (a.sortNum ?? 0) - (b.sortNum ?? 0))
    })
  }

  // 条件判断：只有当图片未加载时才请求图片资源
  // 避免重复加载图片，保持缓存状态
  if (!loadUrl.value.news) {
    const news: any = await asynchronousRetrieval('webimg/images/about_us/news.png');
    loadUrl.value = { news }
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: loadUrl.value.news
      }, null, 8, _hoisted_3),
      _cache[0] || (_cache[0] = _createElementVNode("div", null, "公司动态", -1))
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newsList.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          onClick: ($event: any) => (toOtherPath(item.relatedHtmlId, item.title))
        }, [
          _createElementVNode("div", null, [
            _createElementVNode("img", {
              src: item.ossPath
            }, null, 8, _hoisted_6)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(item.title), 1),
            _createElementVNode("div", _hoisted_9, _toDisplayString(item.introduction), 1),
            _createElementVNode("div", _hoisted_10, _toDisplayString(formatDate(item.newsTimestamp)), 1)
          ])
        ], 8, _hoisted_5))
      }), 128))
    ])
  ]))
}
}

})